<script>
  import StatCard from '../../UC-stat-card.svelte'
  import Button from  '../../Button.svelte'

  export let totalEnrolled = 0
  export let numberComplete = 0
  export let numberNotComplete = 0
  export let numberExempt = 0

  export let selectedFilter = 'totalEnrolled'

  export let itemClasses = ''

  let filterClickHandler = (value) => {
    selectedFilter = value
  }
</script>

<div class="training-summary--wrapper">
  <div class="stat-card-wrapper">
    <StatCard class={ itemClasses } number={ totalEnrolled } units="Total Enrolled" />
    <Button isActive="{ selectedFilter == 'totalEnrolled' }" label="See all" on:click="{ () => filterClickHandler('totalEnrolled') }" isFullWidth="true" />
  </div>
  <div class="stat-card-wrapper">
    <StatCard class={ itemClasses } number={ numberComplete } units="Complete" />
    <Button isActive="{ selectedFilter == 'numberComplete' }" label="See complete" on:click="{ () => filterClickHandler('numberComplete') }" isFullWidth="true" />
  </div>
  <div class="stat-card-wrapper">
    <StatCard class={ itemClasses } number={ numberNotComplete } units="Not Complete" />
    <Button isActive="{ selectedFilter == 'numberNotComplete' }" label="See not complete" on:click="{ () => filterClickHandler('numberNotComplete') }" isFullWidth="true" />
  </div>
  <div class="stat-card-wrapper">
    <StatCard class={ itemClasses } number={ numberExempt } units="Exempt" />
    <Button isActive="{ selectedFilter == 'numberExempt' }" label="See exempt" on:click="{ () => filterClickHandler('numberExempt') }" isFullWidth="true" />
  </div>
</div>

<style>
  .training-summary--wrapper {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    margin: 0 0 30px 0;
    padding: 10px 20px;
    border-radius: 1rem;
  }

  .stat-card-wrapper {
    flex: 0 auto;
    margin: 6px;
  }

  @media(max-width:767px){
    .stat-card-wrapper {
      flex-grow: 1;
    }
  }
</style>